import { render, staticRenderFns } from "./mcn.vue?vue&type=template&id=1db8fabc&"
import script from "./mcn.vue?vue&type=script&lang=js&"
export * from "./mcn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports